import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

axios.defaults.baseURL = "";
axios.defaults.timeout = 5000;
axios.interceptors.request.use(config => {
  config.headers['x-access-token'] = '';
  if (!config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json;charset=utf-8";
  }
  
  return config;
}, error => {
  Message.error("请求发送失败，请检查网络");
  return Promise.reject(error);
});
axios.interceptors.response.use(
  res => {
    if (res) {
      if (
        res.data !== undefined &&
        res.data.code !== undefined &&
        res.data.message !== undefined
      ) {
        const { code, message } = res.data;
        if (code === 200) {
          
        } else if (code === 401) {
         
          local.remove("token"); 
          Message.warning("登录状态已失效，请重新登录");
          router.push("/login");
        } else {
          // Message.error(message); 
        }
      }
      return res;
    }
  },
  error => {
    let errMsg = "请求失败";
    if (error.response) {
      const status = error.response.status;
      if (status === 404) errMsg = "请求地址不存在";
      else if (status === 500) errMsg = "服务器内部错误";
      else errMsg = `请求错误：${status}`;
    } else if (error.request) {
      // errMsg = "请求超时，请检查网络连接";
    }
    // Message.error(errMsg);
    return Promise.reject(error);
  }
);
const handleDownloadResponse = (res, fileName) => {
  const blob = new Blob([res.data], {
    type: res.headers["content-type"] || "application/octet-stream"
  });
  const contentDisposition = res.headers["content-disposition"];
  let downloadFileName = fileName || "下载文件";
  if (contentDisposition) {
    const match = contentDisposition.match(/filename=([^;]+)/);
    if (match && match[1]) {
      downloadFileName = decodeURIComponent(match[1]);
    }
  }
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = downloadFileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  
  Message.success("文件下载成功");
};

export default {
  // GET 请求
  get(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  
  // POST 请求
  post(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  
  // DELETE 请求
  delete(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, { params })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  
  // PUT 请求
  put(url, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, params)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  
  downloadFile({ url, method = "GET", params = {}, fileName = "" }) {
    return new Promise((resolve, reject) => {
      axios({
        url,
        method,
        params: method === "GET" ? params : {}, 
        data: method === "POST" ? params : {},   
        responseType: "blob", 
        headers: {
          "x-access-token": local.get("token"),
          "Content-Type": "application/json;charset=utf-8"
        }
      })
        .then(res => {
          handleDownloadResponse(res, fileName);
          resolve(res);
        })
        .catch(err => {
          Message.error("文件下载失败");
          reject(err);
        });
    });
  }
};